import {
    HStack, VStack
} from '@chakra-ui/react'
import React from 'react'
import { BaseLayout } from '..'
import { MainContentWrapper } from '../Base/MainContent'
import { Checklist } from "./Checklist"
import { SideNav } from './SideNav'
import { UsageStats } from "./UsageStats"

const HomeLayout = (): React.ReactElement => {
    return (
        <BaseLayout>
            <MainContentWrapper>
                <HStack alignItems="start" width="full" spacing={8}>
                    <VStack alignItems="start" width="full" spacing={8}>
                        <Checklist />
                        {/* <WhatsNew /> */}
                        <UsageStats />
                    </VStack>
                    <SideNav />
                </HStack>
            </MainContentWrapper>
        </BaseLayout>
    )
}

export default HomeLayout
